/**
 * Single source of truth for human-friendly visualization type labels.
 * Used by /visualizations, /community, /v/[id], and anywhere else we
 * surface a type to the user. Internal type strings (e.g. "remotion",
 * "generateImage", "scene3d") are developer-y and should NEVER be shown
 * raw — always wrap in getVisualizationTypeLabel().
 */

import { humanizeToolName } from '@/lib/timeline-synthesis';

const LABELS: Record<string, string> = {
  flowchart: 'Flowchart',
  Flowchart: 'Flowchart',
  mermaid: 'Diagram',
  timeline: 'Timeline',
  Timeline: 'Timeline',
  ComparisonTable: 'Comparison',
  comparisonTable: 'Comparison',
  'comparison-table': 'Comparison',
  ConceptMap: 'Concept Map',
  conceptMap: 'Concept Map',
  'concept-map': 'Concept Map',
  CycleDiagram: 'Cycle',
  'cycle-diagram': 'Cycle',
  cycleDiagram: 'Cycle',
  Hierarchy: 'Hierarchy',
  hierarchy: 'Hierarchy',
  Graph: 'Graph',
  graph: 'Graph',
  p5: 'Animation',
  remotion: 'Video',
  hyperframes: 'HTML Video',
  generateImage: 'Image',
  generateVideoClip: 'AI video',
  extractVideoClip: 'Video clip',
  captionVideoClip: 'Captioned clip',
  createVideoRecut: 'Video recut',
  molecule3d: 'Molecule',
  scene3d: '3D Scene',
  createSceneVideo: 'Scene video',
  html: 'HTML',
  htmlNative: 'HTML',
  svg: 'SVG',
  createBrowser: 'Browser',
  browserLiveView: 'Browser',
  browserNavigate: 'Browser',
  browserScroll: 'Browser',
  sandboxPreviewUrl: 'Preview',
  sandboxSync: 'Backup',
  sandboxRestore: 'Restore',
  sandboxListBackups: 'Backups',
  showWorkspace: 'Workspace',
};

export function getVisualizationTypeLabel(type: string): string {
  // Known types get their curated label; unknown ones fall back through the
  // same humanizer the build timeline uses rather than ever showing a raw
  // camelCase/dotted tool id (e.g. "CREATESCENEVIDEO" — CHAT_UI_DESIGN_REVIEW.md
  // §4 item 4).
  return LABELS[type] || humanizeToolName(type);
}
